import {
  FILTER_APPLICANT_COUNT,
  FILTER_DEADLINE,
  FILTER_AMOUNT,
  FILTER_REQ_TYPE,
  FILTER_CONF_SCORE,
  FILTER_PAYMENT
} from '~/lib/utils/filters'

import {
  DEADLINE_FILTER_APPLIED,
  AMOUNT_FILTER_APPLIE,
  REQUIREMENT_FILTER_APPLIED,
  APPLICATION_FILTER_APPLIED,
  CONFIDENCE_SCORE_FILETER_APPLIED,
  PAYMENT_FILTER_APPLIED
} from '~/plugins/mixpanel/events'

const eventProps = {
  [FILTER_APPLICANT_COUNT]: {
    eventName: APPLICATION_FILTER_APPLIED,
    appliedFilterValue: (filterData) => {
      return { min: filterData.min, max: filterData.max }
    }
  },
  [FILTER_DEADLINE]: {
    eventName: DEADLINE_FILTER_APPLIED,
    appliedFilterValue: (filterData) => {
      const items = [
        'Less than 1 day',
        '1 - 7 days',
        '1 - 4 weeks',
        'More than 4 weeks'
      ]

      return { value: items[filterData.selected] }
    }
  },
  [FILTER_AMOUNT]: {
    eventName: AMOUNT_FILTER_APPLIE,
    appliedFilterValue: (filterData) => {
      return { min: filterData.min, max: filterData.max }
    }
  },
  [FILTER_REQ_TYPE]: {
    eventName: REQUIREMENT_FILTER_APPLIED,
    appliedFilterValue: (filterData) => {
      const items = [
        'Essay',
        'Link',
        'Document',
        'Survey',
        'Photo',
        'Question',
        'Video',
        'Special eligibility',
        'Goal'
      ]

      return { values: filterData.selected.map(i => items[i]) }
    }
  },
  [FILTER_CONF_SCORE]: {
    eventName: CONFIDENCE_SCORE_FILETER_APPLIED,
    appliedFilterValue: (filterData) => {
      const items = [
        'Low score (1% - 35%)',
        'Medium score (36% - 69%)',
        'High score (70% - 99%)',
        'Verified'
      ]
      return { values: filterData.selected.map(i => items[i]) }
    }
  },
  [FILTER_PAYMENT]: {
    eventName: PAYMENT_FILTER_APPLIED,
    appliedFilterValue: (filterData) => {
      const items = {
        1: 'College',
        2: 'Student',
        3: 'Non-monetary awards',
        4: 'Not Stated'
      }

      return { 'Payout method selected': filterData.selected.map(i => items[i]) }
    }
  }
}

export const fireMixpanelEvents = ($mixpanel, filters, tabName, $accessor) => {
  Object.keys(filters).forEach((name) => {
    if (!eventProps[name]) { return }
    const event = eventProps[name].eventName
    const props = eventProps[name].appliedFilterValue(filters[name])

    $mixpanel.track(event, {
      tabName,
      ...props,
      'Maintenance mode': $accessor.account.isMaintenanceMode
    })
  })
}
